// extracted by mini-css-extract-plugin
module.exports = {"container":"aed17b9412--container--ch3SI","hand":"aed17b9412--hand--hIE2C"};